import * as React from "react";
import { DateTime } from "../DateTime";
export const PreliveDetails = (props) => React.createElement("div", { className: `rj-ev-list__${props.componentPrefix}__section-item rj-ev-list__${props.componentPrefix}__times`, "data-uat": `div-ev-list-${props.componentPrefix}-times` },
    React.createElement(DateTime, { event: props.event, componentPrefix: props.componentPrefix }));
//# sourceMappingURL=PreliveDetails.js.map